import { http } from './config'
import authHeader from './auth-header';

export default {
  listarTicketsAlocacoes: (params) => {
    return http.get('/servico-funerario/alocacoes', {
      params,
      headers: authHeader()
    })
  },

  listar_favoritos: (params = { tipoData: 'abertos' }) => {
    return http.get('/servico-funerario/favoritos', {
      params,
      headers: authHeader()
    })
  },

  adicionar_favorito: (idAtendimento) => {
    return http.post(`/servico-funerario/favoritos/${idAtendimento}`, null, {
      headers: authHeader()
    })
  },

  compartilhar_favorito: (idAtendimento, idsUsuarios) => {
    return http.post(
      `/servico-funerario/favoritos/${idAtendimento}/compartilhar`,
      { idsUsuarios },
      { headers: authHeader() }
    )
  },

  remover_favorito: (idAtendimento) => {
    return http.delete(`/servico-funerario/favoritos/${idAtendimento}`, {
      headers: authHeader()
    })
  },

  listar_tickets_abertos: (excluidos = false) => {
    return http.get('/servico-funerario/abertos', {
      params: { excluidos },
      headers: authHeader()
    })
  },

  resumo_cards_fluxo_funerario: (params) => {
    return http.get('/servico-funerario/resumo-cards', {
      params,
      paramsSerializer: (queryParams) => {
        const searchParams = new URLSearchParams()
        Object.keys(queryParams || {}).forEach((key) => {
          const value = queryParams[key]
          if (Array.isArray(value)) {
            value.forEach((item) => searchParams.append(key, item))
          } else if (value !== undefined && value !== null && value !== '') {
            searchParams.append(key, value)
          }
        })
        return searchParams.toString()
      },
      headers: authHeader()
    })
  },

  excluir_atendimento: (ticketId) => {
    return http.delete(`/servico-funerario/${ticketId}/excluir`, {
      headers: authHeader()
    })
  },

  atribuir_colaborador: (ticketId, etapaId, colaboradorId) => {
    return http.post('/servico-funerario/atribuir-colaborador', null, {
      params: {
        ticketId,
        etapaId,
        colaboradorId,
      },
      headers: authHeader()
    })
  },

  salvar_atribuicao_etapa: (ticketId, payload) => {
    return http.put(`/servico-funerario/${ticketId}/etapas/atribuicao`, payload, {
      headers: authHeader()
    })
  },

  atualizar_servico: (ticketId, payload) => {
    return http.put(`/servico-funerario/${ticketId}`, payload, {
      headers: authHeader()
    })
  },

  listar_tags: () => {
    return http.get('/servico-funerario/tags', {
      headers: authHeader()
    })
  },

  adicionar_tag: (ticketId, tagId) => {
    return http.post(`/servico-funerario/${ticketId}/tags`, { tagId }, {
      headers: authHeader()
    })
  },

  remover_tag: (ticketId, tagId) => {
    return http.delete(`/servico-funerario/${ticketId}/tags/${tagId}`, {
      headers: authHeader()
    })
  },

  listar_ocupacoes_colaboradores: (params) => {
    return http.get('/servico-funerario/alocacoes/ocupacoes-colaboradores', {
      params,
      headers: authHeader()
    })
  },

  relatorio_funerario: (params) => {
    return http.get('/servico-funerario/relatorios/funerario', {
      params,
      headers: authHeader()
    })
  },

  relatorio_funerario_agentes: () => {
    return http.get('/servico-funerario/relatorios/funerario/agentes', {
      headers: authHeader()
    })
  },

  servicos_particulares: (dataI, dataF, nomeEmpresa, tipo,  opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'opcao': opcao,
          'produto': produto,
      }

      return http.get('/funeraria-dash/servicos-particulares/', {
      params: params,
      headers: authHeader()   
      })  
    },

    servicos_particulares_itens: (dataI, dataF, nomeEmpresa, tipo,  opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'opcao': opcao,
          'produto': produto,
      }

      return http.get('/funeraria-dash/servicos-particulares-itens/', {
      params: params,
      headers: authHeader()   
      })  
    },
    
    servicos_plano_itens: (dataI, dataF, nomeEmpresa, tipo,  opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'opcao': opcao,
          'produto': produto,
      }

      return http.get('/funeraria-dash/servicos-plano-itens/', {
      params: params,
      headers: authHeader()   
      })  
    },

    servicos_pequeninos_itens: (dataI, dataF, nomeEmpresa, tipo,  opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'opcao': opcao,
          'produto': produto,
      }

      return http.get('/funeraria-dash/pequenino-itens/', {
      params: params,
      headers: authHeader()   
      })  
    },
    
    


    servicos_plano_previda: (dataI, dataF, nomeEmpresa, tipo,  opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'opcao': opcao,
          'produto': produto,
      }

      return http.get('/funeraria-dash/servicos-plano-previda/', {
      params: params,
      headers: authHeader()   
      })  
    },

    servicos_pequeninos: (dataI, dataF, nomeEmpresa, tipo,  opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'opcao': opcao,
          'produto': produto,
      }

      return http.get('/funeraria-dash/servicos-pequenino/', {
      params: params,
      headers: authHeader()   
      })  
    },

    
    agrupamento: (dataI, dataF, nomeEmpresa, tipo, filtro,  opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'filtro': filtro,
          'opcao': opcao,
          'produto': produto,
      }

      return http.get('/funeraria-dash/agrupamento/', {
      params: params,
      headers: authHeader()   
      })  
    },

    recebimento_radar: (dataI, dataF) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF
       ,
      }

      return http.get('/funeraria-dash/recebimento-radar/', {
      params: params,
      headers: authHeader()   
      })  
    },
    

    detalhe_obito: (dataI, dataF, nomeEmpresa, tipo,  opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'opcao': opcao,
          'produto': produto,
      }

      return http.get('/funeraria-dash/detalhe-obito/', {
      params: params,
      headers: authHeader()   
      })  
    },

    liberacao_servicos_carencia: (dataI, dataF, nomeEmpresa, tipo,  opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'opcao': opcao,
          'produto': produto,
      }

      return http.get('/funeraria-dash/liberacao-servicos-carencia/', {
      params: params,
      headers: authHeader()   
      })  
    },

    qtd_atendimento: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'filtro': filtro,
          'opcao': opcao,
          'produto': produto,
      }
  
      return http.get('/funeraria-dash/qtd-atendimento/', {
      params: params,
      headers: authHeader()   
      })  
      },

    qtd_naoconformidade: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'filtro': filtro,
          'opcao': opcao,
          'produto': produto,
      }
  
      return http.get('/funeraria-dash/qtd-conformidade/', {
      params: params,
      headers: authHeader()   
      })  
      },
  

    qtd_atendimento_aberto: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto) => {

      const params= {
          'data-inicial': dataI,
          'data-final': dataF,
          'empresa': nomeEmpresa,
          'tipo': tipo,
          'filtro': filtro,
          'opcao': opcao,
          'produto': produto,
      }
  
      return http.get('/funeraria-dash/qtd-atendimento-aberto/', {
      params: params,
      headers: authHeader()   
      })  
      },

      qtd_atendimento_min: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto) => {

        const params= {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'filtro': filtro,
            'opcao': opcao,
            'produto': produto,
        }
    
        return http.get('/funeraria-dash/qtd-atendimento-min/', {
        params: params,
        headers: authHeader()   
        })  
        },

      lista_ranking_qtd: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto) => {

        const params= {
            'data-inicial': dataI,
            'data-final': dataF,
            'empresa': nomeEmpresa,
            'tipo': tipo,
            'filtro': filtro,
            'opcao': opcao,
            'produto': produto,
        }

        return http.get('/funeraria-dash/lista-ranking-qtd/', {
        params: params,
        headers: authHeader()   
        })  
        },

        lista_ranking_min: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto) => {

          const params= {
              'data-inicial': dataI,
              'data-final': dataF,
              'empresa': nomeEmpresa,
              'tipo': tipo,
              'filtro': filtro,
              'opcao': opcao,
              'produto': produto,
          }
  
          return http.get('/funeraria-dash/lista-ranking-min/', {
          params: params,
          headers: authHeader()   
          })  
          },

          lista_funeraria: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto) => {

            const params= {
                'data-inicial': dataI,
                'data-final': dataF,
                'empresa': nomeEmpresa,
                'tipo': tipo,
                'filtro': filtro,
                'opcao': opcao,
                'produto': produto,
            }
    
            return http.get('/funeraria-dash/lista-funeraria/', {
            params: params,
            headers: authHeader()   
            })  
            },

  etapa_atividades: (ticketFunerarioEtapaId) => {
    return http.get(`/servico-funerario/etapa-atividades/ticket-etapa/${ticketFunerarioEtapaId}`, {
      headers: authHeader()
    })
  },

  atividades_etapa: (etapaId) => {
    return http.get(`/servico-funerario/atividades/etapa/${etapaId}`, {
      headers: authHeader()
    })
  },

  adicionar_atividade: (dto) => {
    return http.post(`/servico-funerario/etapa-atividades`, dto, {
      headers: authHeader()
    })
  },
  editar_atividade: (dto, id) => {
    return http.put(`/servico-funerario/etapa-atividades/${id}`, dto, {
      headers: authHeader()
    })
  },

  excluir_atividade: (id) => {
    return http.delete(`/servico-funerario/etapa-atividades/${id}`, {
      headers: authHeader()
    })
  },

  // Itens do atendimento
  listar_produtos_urna: () => {
    return http.get('/servico-funerario/produtos-urnas', {
      headers: authHeader()
    })
  },

  listar_urnas_qrcode: () => {
    return http.get('/servico-funerario/urnas-qrcode', {
      headers: authHeader()
    })
  },

  exportar_fluxo_funerario_xls: (params = {}) => {
    return http.get('/servico-funerario/tickets-xls', {
      params,
      headers: authHeader(),
      responseType: 'blob'
    })
  },

  excluir_item_atendimento: (idItem) => {
    return http.delete(`/servico-funerario/item/${idItem}`, {
      headers: authHeader()
    })
  },

  trocar_urna: (itemAntigoId, novoProdutoId, idGrade, novoValor, desconto) => {
    return http.post('/servico-funerario/trocar-urna', {
      itemAntigoId,
      novoProdutoId,
      idGrade,
      novoValor,
      desconto
    }, {
      headers: authHeader()
    })
  },

  validar_urna_item: (itemId, qrcode) => {
    return http.post(`/servico-funerario/item/${itemId}/urna/validar`, {
      qrcode
    }, {
      headers: authHeader()
    })
  },

  trocar_urna_por_qrcode: (itemId, qrcode) => {
    return http.post(`/servico-funerario/item/${itemId}/urna/trocar-por-qrcode`, {
      qrcode,
      confirmarInvalidacao: true
    }, {
      headers: authHeader()
    })
  },

  aplicar_desconto_item: (idItem, desconto) => {
    return http.put('/servico-funerario/item/desconto', {
      idItem,
      desconto
    }, {
      headers: authHeader()
    })
  },

  recarregar_cobertura: (idAtendimento) => {
    return http.post('/servico-funerario/recarregar-cobertura', {
      idAtendimento
    }, {
      headers: authHeader()
    })
  },

  sincronizar_atendimento: (ticketId) => {
    return http.post(`/servico-funerario/${ticketId}/sincronizar-atendimento`, null, {
      headers: authHeader()
    })
  },

  criar_atendimento_manual: (dto) => {
    return http.post('/servico-funerario/criar', dto, {
      headers: authHeader()
    })
  },

  atualizar_item: (idItem, dto) => {
    return http.put(`/servico-funerario/item/${idItem}`, dto, {
      headers: authHeader()
    })
  },

  consultar_itens_cobertura: (idAtendimento) => {
    return http.get(`/servico-funerario/itens-cobertura/${idAtendimento}`, {
      headers: authHeader()
    })
  },

  adicionar_item: (dto) => {
    return http.post('/servico-funerario/item', dto, {
      headers: authHeader()
    })
  },

  // Procedimentos de conclusão do atendimento
  listar_procedimentos: () => {
    return http.get('/servico-funerario/procedimentos', {
      headers: authHeader()
    })
  },

  consultar_procedimentos_ticket: (ticketId) => {
    return http.get(`/servico-funerario/${ticketId}/procedimentos`, {
      headers: authHeader()
    })
  },

  salvar_procedimentos_ticket: (ticketId, dto) => {
    return http.post(`/servico-funerario/${ticketId}/procedimentos`, dto, {
      headers: authHeader()
    })
  },

  atualizar_procedimento_ticket: (ticketId, id, dto) => {
    return http.put(`/servico-funerario/${ticketId}/procedimentos/${id}`, dto, {
      headers: authHeader()
    })
  },

  excluir_procedimento_ticket: (ticketId, id) => {
    return http.delete(`/servico-funerario/${ticketId}/procedimentos/${id}`, {
      headers: authHeader()
    })
  },

}
